<template>
  <div style="background-color: #fff">
    <div class="BlockList">
      <div class="BlockList-W">
        <div class="paidbox" v-show="flag">
          <div class="paidboxlist">
            <div class="paidboxtit">
              Please use Tree Wallet to scan the OR code below to complete<br />
              the payment to successfully complete the contract release<br />process
            </div>
            <div class="qrcode">
              <div id="qrcode" ref="qrcode"></div>
            </div>
            <div class="button" @click="paids">I scanned and paid</div>
            <div class="bottom">
              <div class="bottomtit">Back to Contract Deployment</div>
              <img src="../../../assets/pc/Index/right.png" />
            </div>
          </div>
        </div>
        <div class="paidbox1" v-show="flaga">
          <div class="paidboxlist">
            <div class="paidtit1">
              Congratulations! Your contract has been successfully published!
            </div>
            <div class="paidtit2">
              You can view your contract<br />
              through the Transformers<br />
              browser.
            </div>
            <div class="paidtitbtn">OK</div>
          </div>
        </div>
        <div class="paidbox2" v-show="flagb">
          <div class="paidboxlist">
            <div class="paidtit1">
              I'm sorry, but your contract information has not been detected yet
            </div>
            <div class="paidtit2">
              This may be due to the following reasons:
            </div>
            <div class="paidtit3">
              1.Network delay, please try refreshing the page and resubmitting
              your request.
            </div>
            <div class="paidtit3">
              2. Please confirm that your Tree Wallet has successfully scanned
              the QR code, completed the payment. and successfully published the
              contract.
            </div>
            <div class="paidtitbtn">OK</div>
            <div class="paidtitbottom">
              <div class="bottomtit">Back to Contract Deployment</div>
              <img src="../../../assets/pc/Index/right.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Listbox from "@/components/pc/Listbox.vue";
// import Homseach from "@/components/pc/serch.vue";
// import Homeinput from "../Home/Home_input.vue";
import QRCode from "qrcodejs2";
import Editor from "vue2-ace-editor";
import axios from "axios";
//黑底色
import "brace/theme/tomorrow_night_eighties";
//蓝底色
import "brace/theme/tomorrow_night_blue";
//黑底色
import "brace/theme/vibrant_ink";

import { GetvertifyContract } from "@/assets/server/api";
export default {
  data() {
    return {
      flag: true,
      flaga: false,
      flagb: false,
    };
  },
  components: {},
  created() {},
  mounted() {
    // this.BlockList();
  },
  methods: {
    paids() {
      this.flag = false;
      this.flagb = true;
    },
  },
};
</script>

<style lang="less" scoped>
html,
body {
  background: #f4f7fd !important;
}
.BlockList {
  width: 100%;
  background: #f4f7fd;
  .BlockList-W {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 36px;
    background: #f4f7fd;
    padding-top: 112px;
    padding-bottom: 600px;
    .paidbox {
      width: 1384px;
      margin: 0 auto;
      height: 532px;
      background: #ffffff;
      border-radius: 10px 10px 10px 10px;
      opacity: 1;
      border: 2px solid rgba(201, 219, 255, 0.8);
      .paidboxlist {
        width: 646px;
        margin: 0 auto;
        padding-top: 32px;
        text-align: center;
        .paidboxtit {
          font-size: 20px;
          font-family: Roboto, Roboto;
          font-weight: 500;
          color: #000000;
          line-height: 29px;
        }
        .qrcode {
          width: 200px;
          height: 200px;
          border: 1px solid red;
          margin-left: 240px;
          margin-top: 40px;
          margin-bottom: 40px;
        }
        .button {
          width: 335px;
          height: 56px;
          line-height: 56px;
          background: #1395ff;
          border-radius: 6px 6px 6px 6px;
          opacity: 1;
          font-size: 24px;
          font-family: Roboto, Roboto;
          font-weight: 600;
          color: #ffffff;
          text-align: center;
          margin-left: 155px;
          margin-bottom: 14px;
        }
        .bottom {
          display: flex;
          margin-left: 155px;
          .bottomtit {
            font-size: 20px;
            font-family: Roboto, Roboto;
            font-weight: 500;
            color: #1395ff;
            margin-right: 6px;
          }
        }
      }
    }
    .paidbox1 {
      width: 1384px;
      height: 350px;
      background: #ffffff;
      border-radius: 10px 10px 10px 10px;
      opacity: 1;
      border: 2px solid rgba(201, 219, 255, 0.8);
      margin: 0 auto;
      .paidboxlist {
        width: 646px;
        margin: 0 auto;
        padding-top: 32px;
        text-align: center;
        .paidtit1 {
          font-size: 26px;
          font-family: Roboto, Roboto;
          font-weight: 700;
          line-height: 29px;
          color: #0c5dff;
        }
        .paidtit2 {
          font-size: 20px;
          font-family: Roboto, Roboto;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.8);
          line-height: 29px;
          margin-top: 20px;
          margin-bottom: 40px;
        }
        .paidtitbtn {
          width: 138px;
          height: 56px;
          background: #1395ff;
          border-radius: 6px 6px 6px 6px;
          opacity: 1;
          line-height: 56px;
          text-align: center;
          margin: 0 auto;
          font-size: 24px;
          font-family: Roboto, Roboto;
          font-weight: 600;
          color: #ffffff;
        }
      }
    }
    .paidbox2 {
      width: 1384px;
      height: 350px;
      background: #ffffff;
      border-radius: 10px 10px 10px 10px;
      opacity: 1;
      border: 2px solid rgba(201, 219, 255, 0.8);
      margin: 0 auto;
      .paidboxlist {
        width: 646px;
        margin: 0 auto;
        padding-top: 32px;
        text-align: center;
      
      
        .paidtit3 {
          font-size: 16px;
          font-family: Roboto, Roboto;
          line-height: 29px;
        }
        .paidtit4 {
        }
        .paidtit1 {
          font-size: 26px;
          font-family: Roboto, Roboto;
          font-weight: 700;
          line-height: 29px;
          color: #0c5dff;
        }
        .paidtit2 {
          font-size: 20px;
          font-family: Roboto, Roboto;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.8);
          line-height: 29px;
          margin-top: 20px;
        
        }
        .paidtitbtn {
          width: 138px;
          height: 56px;
          background: #1395ff;
          border-radius: 6px 6px 6px 6px;
          opacity: 1;
          line-height: 56px;
          text-align: center;
          margin: 0 auto;
          font-size: 24px;
          font-family: Roboto, Roboto;
          font-weight: 600;
          color: #ffffff;
        }
        .paidtitbottom {
          display: flex;
          margin-left: 155px;
          margin-top: 14px;
          .bottomtit {
            font-size: 20px;
            font-family: Roboto, Roboto;
            font-weight: 500;
            color: #1395ff;
            margin-right: 6px;
          }
        }
      }
    }
  }
}
</style>
